class AdvancedSlider {
  /*
   * Perf (audit C3): shared measure→mutate scheduler. With 6-8 slider
   * instances per page, each init used to read clientWidth, write slide
   * styles, then read offsetWidth again — interleaved reads/writes across
   * instances forced a fresh synchronous layout per slider (measured 138ms
   * of forced layout on the homepage). Init and resize refreshes now queue
   * here: ONE frame does every instance's reads first, then every
   * instance's writes. Interaction paths (arrows/dots/drag) stay
   * synchronous — they touch a single instance and need instant response.
   */
  static _refreshQueue = new Map();
  static _refreshScheduled = false;

  static scheduleRefresh(instance, skipTransition = false) {
    const prev = AdvancedSlider._refreshQueue.get(instance);
    AdvancedSlider._refreshQueue.set(instance, prev === undefined ? skipTransition : prev || skipTransition);
    if (AdvancedSlider._refreshScheduled) return;
    AdvancedSlider._refreshScheduled = true;
    requestAnimationFrame(() => {
      const entries = Array.from(AdvancedSlider._refreshQueue);
      AdvancedSlider._refreshQueue.clear();
      AdvancedSlider._refreshScheduled = false;
      // Read phase — no DOM writes allowed here.
      const widths = entries.map(([instance]) => instance.slider.clientWidth);
      // Write phase — widths are passed in so update() never re-measures.
      entries.forEach(([instance, skip], i) => instance.update(skip, widths[i]));
    });
  }

  constructor(slider) {
    this.slider = slider;
    this.track = slider.querySelector('.slider-track');
    this.slides = Array.from(this.track.children);
    this.currentIndex = 0;

    this.settings = {
      arrows: slider.dataset.arrows === 'true',
      dots: slider.dataset.dots === 'true',
      draggable: slider.dataset.draggable === 'true',
      loop: slider.dataset.loop === 'true',
      autoplay: slider.dataset.autoplay === 'true',
      autoplayDelay: parseInt(slider.dataset.autoplaydelay || '4000'),
      gap: parseInt(slider.dataset.gap || '15'),
      slidesDesktop: parseFloat(slider.dataset.slidesDesktop || '3'),
      slidesTablet: parseFloat(slider.dataset.slidesTablet || '2'),
      slidesMobile: parseFloat(slider.dataset.slidesMobile || '1'),
      scrollDesktop: parseFloat(slider.dataset.scrollDesktop || '1'),
      scrollTablet: parseFloat(slider.dataset.scrollTablet || '1'),
      scrollMobile: parseFloat(slider.dataset.scrollMobile || '1'),
      autoHeight: slider.dataset.autoheight === 'true' // 👈 new option
    };

    this.touch = { startX: 0, active: false };
    this.autoplayTimer = null;

    this.setup();
  }

  setup() {
    this.setResponsive();
    this.createControls();
    this.attachEvents();
    // Initial layout (incl. autoHeight) runs through the shared scheduler so
    // all sliders on the page measure together, then write together.
    AdvancedSlider.scheduleRefresh(this, true);
    if (this.settings.autoplay) this.startAutoplay();
  }

  setResponsive() {
    const width = window.innerWidth;
    if (width < 768) {
      this.slidesToShow = this.settings.slidesMobile;
      this.slidesToScroll = this.settings.scrollMobile;
      this.currentGap = 5;
    } else if (width < 1024) {
      this.slidesToShow = this.settings.slidesTablet;
      this.slidesToScroll = this.settings.scrollTablet;
      this.currentGap = this.settings.gap;
    } else {
      this.slidesToShow = this.settings.slidesDesktop;
      this.slidesToScroll = this.settings.scrollDesktop;
      this.currentGap = this.settings.gap;
    }

    if (this.settings.dots) {
      this.rebuildDots();
    }
  }

  createControls() {
    if (this.slides.length <= this.slidesToShow) return;

    if (this.settings.arrows) {
      const prev = document.createElement('button');
      const next = document.createElement('button');
      prev.className = 'slider-arrow prev';
      next.className = 'slider-arrow next';
      prev.setAttribute('aria-label', 'Previous slide');
      next.setAttribute('aria-label', 'Next slide');
      this.prevBtn = prev;
      this.nextBtn = next;
      prev.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" focusable="false" color="var(--token-6c510ae1-7654-486d-9239-3be193299ea9, rgb(255, 255, 255))" style="user-select: none; width: 100%; height: 100%; display: inline-block; fill: var(--token-6c510ae1-7654-486d-9239-3be193299ea9, rgb(255, 255, 255)); color: var(--token-6c510ae1-7654-486d-9239-3be193299ea9, rgb(255, 255, 255)); flex-shrink: 0;"><path d="M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z"></path></svg>`;
      next.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" focusable="false" color="var(--token-6c510ae1-7654-486d-9239-3be193299ea9, rgb(255, 255, 255))" style="user-select: none; width: 100%; height: 100%; display: inline-block; fill: var(--token-6c510ae1-7654-486d-9239-3be193299ea9, rgb(255, 255, 255)); color: var(--token-6c510ae1-7654-486d-9239-3be193299ea9, rgb(255, 255, 255)); flex-shrink: 0;"><path d="M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z"></path></svg>`;
      prev.addEventListener('click', () => this.move(-1));
      next.addEventListener('click', () => this.move(1));
      //this.slider.append(prev, next);
     
        // const mainWrap = this.slider.closest('.itg_expert_advisory_main');
        // const iconWrapper = mainWrap ? mainWrap.querySelector('.itg_expert_head .itg_expert_slideicon'): null;
        // if (iconWrapper) {
        //   iconWrapper.append(prev, next);
        // } else {
        //   this.slider.append(prev, next);
        // }

        if (window.innerWidth > 750) {
        const mainWrap = this.slider.closest('.itg_expert_advisory_main') || this.slider.closest('.itg_founder_main');
        const iconWrapper = mainWrap
          ? mainWrap.querySelector('.itg_expert_head .itg_expert_slideicon') || mainWrap.querySelector('.itg_founder_head .itg_founder_slideicon')
          : null;

          if (iconWrapper) {
            iconWrapper.append(prev, next);
          } else {
            this.slider.append(prev, next);
          }
      }else{
        const mainWrap = this.slider.closest('.itg_expert_advisory_main') || this.slider.closest('.itg_founder_main');
        const iconWrapper = mainWrap
          ? mainWrap.querySelector('.itg_expert_img_text .itg_expert_slideicon_moblie') || mainWrap.querySelector('.itg_founder_slider .itg_founder_slideicon_mobile')
          : null;

          if (iconWrapper) {
            iconWrapper.append(prev, next);
          } else {
            this.slider.append(prev, next);
          }
      }
 
    }

    if (this.settings.dots) {
      this.dotsContainer = document.createElement('div');
      this.dotsContainer.className = 'slider-dots';
      this.slider.appendChild(this.dotsContainer);
      this.rebuildDots();
      this.dotsContainer.querySelectorAll('button.dot').forEach((dot, index) => {
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      });
    }


    
  }

  rebuildDots() {
    if (!this.dotsContainer) return;
    this.dotsContainer.innerHTML = '';
    const total = Math.ceil((this.slides.length - this.slidesToShow) / this.slidesToScroll) + 1;
    for (let i = 0; i < total; i++) {
      const dot = document.createElement('button');
      dot.className = 'dot';
      dot.addEventListener('click', () => {
        this.currentIndex = i * this.slidesToScroll;
        this.update();
        this.restartAutoplay();
      });
      this.dotsContainer.appendChild(dot);
    }
    this.updateDots();
  }

  attachEvents() {
    window.addEventListener('resize', () => {
      this.setResponsive();
      // Batched: all sliders re-measure/re-render together once per frame.
      AdvancedSlider.scheduleRefresh(this, true);
    });

    if (this.settings.draggable) {
      this.track.addEventListener('mousedown', e => this.dragStart(e));
      this.track.addEventListener('touchstart', e => this.dragStart(e));
      this.track.addEventListener('mousemove', e => this.dragMove(e));
      this.track.addEventListener('touchmove', e => this.dragMove(e));
      this.track.addEventListener('mouseup', () => this.dragEnd());
      this.track.addEventListener('touchend', () => this.dragEnd());
      this.track.addEventListener('mouseleave', () => this.dragEnd());
    }

    // Trackpad / mousepad horizontal scroll support
    this._wheelDelta = 0;
    this._wheelTimeout = null;
    this.slider.addEventListener('wheel', e => this.handleWheel(e), { passive: false });
  }

  update(skipTransition = false, measuredWidth = null) {
    const gap = this.currentGap;
    const visibleSlides = this.slidesToShow;
    const totalSlides = this.slides.length;

    // measuredWidth comes from the scheduler's read phase; interaction paths
    // (single instance) fall back to a direct read.
    const containerWidth = measuredWidth ?? this.slider.clientWidth;
    const slideWidthPx = (containerWidth - (gap * (visibleSlides - 1))) / visibleSlides;
    this._lastSlideWidthPx = slideWidthPx;

    this.slides.forEach(slide => {
      slide.style.flex = `0 0 ${slideWidthPx}px`;
      slide.style.width = `${slideWidthPx}px`;
    });

    // maxIndex is in SLIDE units, matching currentIndex — translateX below
    // multiplies currentIndex by the slide step, move() advances it by
    // slidesToScroll, and rebuildDots() sets it to `page * slidesToScroll`.
    //
    // This previously divided by slidesToScroll, expressing it in PAGE units.
    // The two are identical while slidesToScroll is 1, which was the default
    // every slider on the site used, so it went unnoticed. With a larger scroll
    // step it clamped currentIndex to a single page's worth of slides: the arrow
    // advanced once and then appeared stuck.
    const maxIndex = Math.max(0, totalSlides - visibleSlides);
    if (!this.settings.loop) {
      this.currentIndex = Math.max(0, Math.min(this.currentIndex, maxIndex));
    } else {
      if (this.currentIndex > maxIndex) this.currentIndex = 0;
      if (this.currentIndex < 0) this.currentIndex = maxIndex;
    }

    const translateX = (slideWidthPx + gap) * this.currentIndex * -1;

    this.track.style.transition = skipTransition ? 'none' : 'transform 0.5s ease';
    this.track.style.transform = `translateX(${translateX}px)`;
    this.track.style.gap = `${gap}px`;

    this.updateDots();
    this.updateArrowVisibility(maxIndex);

    // 👇 Auto height adjust after each update
    if (this.settings.autoHeight) this.adjustHeight();
  }

  updateArrowVisibility(maxIndex) {
    if (!this.prevBtn || !this.nextBtn) return;

    const navigable = this.slides.length > this.slidesToShow;
    let hidePrev, hideNext;

    if (!navigable) {
      hidePrev = true;
      hideNext = true;
    } else if (this.settings.loop) {
      hidePrev = false;
      hideNext = false;
    } else {
      hidePrev = this.currentIndex <= 0;
      hideNext = this.currentIndex >= maxIndex;
    }

    this.prevBtn.style.display = hidePrev ? 'none' : '';
    this.nextBtn.style.display = hideNext ? 'none' : '';
  }

  adjustHeight() {
    const visibleSlides = this.slides.slice(
      this.currentIndex,
      this.currentIndex + this.slidesToShow
    );

    let maxHeight = 0;

    visibleSlides.forEach(slide => {
      const img = slide.querySelector('img');
      if (img) {
        if (img.complete) {
          // Perf (audit C3): update() just wrote each slide's width to
          // _lastSlideWidthPx, so use that instead of reading offsetWidth —
          // the read forced a synchronous layout right after the writes.
          const slideWidth = this._lastSlideWidthPx || slide.offsetWidth;
          maxHeight = Math.max(maxHeight, img.naturalHeight * (slideWidth / img.naturalWidth));
        } else {
          img.addEventListener('load', () => this.adjustHeight(), { once: true });
        }
      } else {
        maxHeight = Math.max(maxHeight, slide.offsetHeight);
      }
    });

    if (maxHeight > 0) {
      this.slider.style.height = `${maxHeight}px`;
      this.track.style.height = `${maxHeight}px`;
    }
  }

  updateDots() {
    if (!this.dotsContainer) return;
    const dots = Array.from(this.dotsContainer.children);
    dots.forEach(dot => dot.classList.remove('active'));
    const activeDot = Math.round(this.currentIndex / this.slidesToScroll);
    if (dots[activeDot]) dots[activeDot].classList.add('active');
  }

  move(direction) {
    this.currentIndex += direction * this.slidesToScroll;
    this.update();
    this.restartAutoplay();
  }

  handleWheel(e) {
    // Only handle when horizontal delta dominates (trackpad horizontal swipe)
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 1) return;

    // Don't scroll if all slides are visible
    if (this.slides.length <= this.slidesToShow) return;

    e.preventDefault();

    const gap = this.currentGap;
    // Perf (audit C3): wheel events fire continuously — reuse the width from
    // the last update() instead of forcing a layout read per event.
    const slideWidthPx = this._lastSlideWidthPx ??
      ((this.slider.clientWidth - (gap * (this.slidesToShow - 1))) / this.slidesToShow);
    const step = slideWidthPx + gap;
    // Slide units, as in update() — minTranslate multiplies this by the slide
    // step, so a page-unit value would stop the wheel short of the last slide.
    const maxIndex = Math.max(0, this.slides.length - this.slidesToShow);
    const minTranslate = step * maxIndex * -1;

    // Accumulate delta for smooth feel
    this._wheelDelta += e.deltaX;

    // Calculate new translate from current snapped position + accumulated delta
    const baseTranslate = step * this.currentIndex * -1;
    let newTranslate = baseTranslate - this._wheelDelta;

    // Clamp within bounds
    newTranslate = Math.max(minTranslate, Math.min(0, newTranslate));

    this.track.style.transition = 'none';
    this.track.style.transform = `translateX(${newTranslate}px)`;

    // Debounce: snap to nearest slide when scrolling stops
    clearTimeout(this._wheelTimeout);
    this._wheelTimeout = setTimeout(() => {
      const rawIndex = Math.round(Math.abs(newTranslate) / step);
      this.currentIndex = Math.max(0, Math.min(rawIndex, maxIndex));
      this._wheelDelta = 0;
      this.update();
      this.restartAutoplay();
    }, 150);
  }

  dragStart(e) {
    this.touch.active = true;
    this.touch.startX = e.touches ? e.touches[0].pageX : e.pageX;
  }

  dragMove(e) {
    if (!this.touch.active) return;
    const currentX = e.touches ? e.touches[0].pageX : e.pageX;
    const dist = this.touch.startX - currentX;
    if (Math.abs(dist) > 50) {
      this.move(dist > 0 ? 1 : -1);
      this.touch.active = false;
    }
  }

  dragEnd() {
    this.touch.active = false;
  }

  startAutoplay() {
    this.autoplayTimer = setInterval(() => this.move(1), this.settings.autoplayDelay);
  }

  restartAutoplay() {
    if (!this.settings.autoplay) return;
    clearInterval(this.autoplayTimer);
    this.startAutoplay();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.custom-slider').forEach(slider => {
    // The script may be loaded twice (global module in scripts.liquid + classic
    // per-section tags); a DOM flag is the only state shared across both scopes.
    if (slider.dataset.sliderInitialized) return;
    slider.dataset.sliderInitialized = 'true';
    new AdvancedSlider(slider);
  });
});